module.exports = __webpack_public_path__ + "assets/img/99e564d8ac5acb35be1d3ae91c152fe9.png";